import { render, staticRenderFns } from "./RidesTable.vue?vue&type=template&id=28d02bec&"
import script from "./RidesTable.vue?vue&type=script&lang=js&"
export * from "./RidesTable.vue?vue&type=script&lang=js&"
import style0 from "./RidesTable.vue?vue&type=style&index=0&id=28d02bec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports